// src/types/currency.ts
export type CurrencyCode = 'EGP';
export type LegacyCurrencyCode = 'SAR' | 'QAR' | 'USD' | 'EUR';

export interface Currency {
  code: CurrencyCode;
  name: string;
  nameAr: string;
  symbol: string;
  symbolAr: string;
  position: 'before' | 'after'; // موضع الرمز قبل أو بعد الرقم
  decimals: number;
  locale: string; // للتنسيق الصحيح للأرقام
}

export const CURRENCIES: Record<CurrencyCode, Currency> = {
  EGP: {
    code: 'EGP',
    name: 'Egyptian Pound',
    nameAr: 'جنيه مصري',
    symbol: 'EGP',
    symbolAr: 'ج.م',
    position: 'after',
    decimals: 2,
    locale: 'ar-EG',
  },
};

export const DEFAULT_CURRENCY: CurrencyCode = 'EGP';

// Legacy documents used several labels without converting the numeric value.
// Active reads therefore normalize the label to the platform currency.
export const normalizeCurrencyCode = (
  _value: CurrencyCode | LegacyCurrencyCode | string | null | undefined
): CurrencyCode => DEFAULT_CURRENCY;
